import { ScoreComponent } from './ScoreComponentsVisual';

interface WeightStepGridProps {
  components: ScoreComponent[];
}

export function WeightStepGrid({ components }: WeightStepGridProps) {
  const withSteps = components.filter(c => c.weightSteps && c.weightSteps.length > 0);
  if (withSteps.length === 0) return null;

  return (
    <div className="mb-5">
      <p className="text-[10px] font-semibold uppercase tracking-wide text-gray-400 mb-2">
        Weight scale per component
      </p>
      <div className="grid grid-cols-2 gap-2">
        {withSteps.map(comp => (
          <div
            key={comp.key}
            className="rounded-md border px-2.5 py-2"
            style={{ borderColor: `${comp.hex}40`, backgroundColor: `${comp.hex}06` }}
          >
            <p
              className="text-[10px] font-bold uppercase tracking-wide mb-1.5"
              style={{ color: comp.textHex }}
            >
              {comp.label}
            </p>
            <table className="w-full">
              <tbody>
                {comp.weightSteps!.map((step, i) => {
                  const isMax = i === 0;
                  return (
                    <tr key={i}>
                      <td className="text-[10px] text-gray-500 py-0.5 pr-3">{step.condition}</td>
                      <td className="text-right">
                        <div className="flex items-center justify-end gap-1.5">
                          <div className="w-10 bg-gray-100 rounded-full h-1 overflow-hidden">
                            <div
                              className="h-full rounded-full"
                              style={{
                                width:
                                  comp.weightSteps![0].weight > 0
                                    ? `${(step.weight / comp.weightSteps![0].weight) * 100}%`
                                    : '0%',
                                backgroundColor: step.weight > 0 ? comp.hex : '#D1D5DB',
                              }}
                            />
                          </div>
                          <span
                            className="text-[10px] font-semibold tabular-nums w-7 text-right"
                            style={{ color: step.weight > 0 ? comp.textHex : '#9CA3AF' }}
                          >
                            {step.weight.toFixed(2)}
                          </span>
                          {isMax && step.weight > 0 && (
                            <span
                              className="text-[9px] font-bold px-1 rounded"
                              style={{ backgroundColor: comp.hex, color: '#fff' }}
                            >
                              max
                            </span>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ))}
      </div>
      <div className="mt-4 border-t border-gray-100" />
    </div>
  );
}
